import PropTypes from 'prop-types';
import React from 'react';

import { trackMenuItemClick } from '@/helpers/dataLayer';

import { LinkWrapper } from './Link.style';

const Link = ({
  href,
  title,
  className,
  closeNavigation,
  openInNewTab,
  'data-test-subject': dataTestSubject,
}) => {
  return (
    <LinkWrapper
      href={href}
      data-test-subject={dataTestSubject || 'mobile-nav-link'}
      onClick={() => {
        closeNavigation();
        trackMenuItemClick();
      }}
      className={className}
      {...(openInNewTab && {
        target: '_blank',
        rel: 'noopener noreferrer',
      })}>
      {title}
    </LinkWrapper>
  );
};

Link.propTypes = {
  href: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  className: PropTypes.string,
  'data-test-subject': PropTypes.string,
  closeNavigation: PropTypes.func.isRequired,
  openInNewTab: PropTypes.bool,
};

export default Link;
